import { useNavigate } from 'react-router-dom';
import { useUser } from '../../lib/firebase/use-user.js';
import { timeAgo } from '../../lib/utils/time.js';
import type { Tip } from '../../types/tip.js';

export function TipRow({ tip }: { tip: Tip }) {
  const nav = useNavigate();
  const author = useUser(tip.createdBy);

  // 1 行抜粋。Markdown 記法は雑に剥がして冒頭 100 文字
  const excerpt = tip.body
    .replace(/```[\s\S]*?```/g, ' ')
    .replace(/[#*_`>-]+/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 100);

  return (
    <div
      className="row"
      style={{ gridTemplateColumns: '1fr auto' }}
      onClick={() => nav(`/tips/${tip.id}`)}
    >
      <div>
        <div className="row-title">{tip.title}</div>
        <div style={{ fontSize: 12, color: 'var(--ink-3)', margin: '4px 0 8px', lineHeight: 1.55 }}>
          {excerpt}
        </div>
        <div className="row-meta">
          {tip.tags.slice(0, 3).map((t) => (
            <span key={t} className="tag">
              <span className="tag-dot" />
              {t}
            </span>
          ))}
          {author.data && (
            <>
              <span className="dot-sep">·</span>
              <span>{author.data.name}</span>
            </>
          )}
          <span className="dot-sep">·</span>
          <span>{timeAgo(tip.createdAt)}</span>
        </div>
      </div>
    </div>
  );
}
